import VJumbotron from './VJumbotron'

export { VJumbotron }
export default VJumbotron
